import { formatMoney, formatMoneyCents } from 'services/util'

import greenCheck from '../components/images/check-circle.svg'

import css from './sass/mypages.module.scss'

export default function MyFixedItemRow({item, currentUserId}) {

  const amountPaidFor = (item.Payments || []).reduce((sum, payment) => {
    if (payment.UserId === currentUserId) return sum + payment.Quantity
    return sum
  }, 0)

  const itemFullyPaid = (item.MyAmountPurchased === amountPaidFor)

  return (
    <div className={css['myitems-row']}>
      <h3 className={css['mypages-headings']}>{item.Title}</h3>
      <div className={css['myitems-amount']}>
        <div className={css['myitems-amount-left']}>
          <p>Total Price</p>
          <h2 className={css['mypages-headings']}>{`$${formatMoney(item.PurchasePrice * item.MyAmountPurchased)}`}</h2>
        </div>
        <div className={css['myitems-amount-right']}>
          <div className={css['myfixeditems-container']}>
            <p>Quantity: <span>{item.MyAmountPurchased}</span></p>
            <p>Item Price: <span>${item.PurchasePrice}</span></p>
          </div>
          {itemFullyPaid && <>
              <img className={css['myitems-paid-icon']} src={greenCheck} />
              <p className={css['myitems-paid-text']}>Paid</p>
            </>
          }
        </div>
      </div>
    </div>
  )
}
